import { IRoomRepository } from '../ports/IRoomRepository';
import { calculateAverage, getNearestFibonacci } from '../../domain/valueObjects/FibonacciDeck';
import { getMostCommonSize } from '../../domain/valueObjects/TShirtDeck';
import { DeckType, VotingRound } from '../../domain/entities/Room';

export class RevealVotesUseCase {
  constructor(private roomRepo: IRoomRepository) {}

  async execute(
    roomId: string,
    story: string,
    votes: Record<string, string>,
    deckType: DeckType = 'fibonacci'
  ): Promise<VotingRound> {
    await this.roomRepo.revealVotes(roomId);

    const voteValues = Object.values(votes).filter(v => v !== null) as string[];

    let average: number | null = null;
    let finalEstimate: string | null = null;

    if (deckType === 'tshirt') {
      finalEstimate = getMostCommonSize(voteValues);
    } else {
      average = calculateAverage(voteValues);
      finalEstimate = average !== null ? getNearestFibonacci(average) : null;
    }

    const round: VotingRound = {
      story,
      votes,
      average,
      finalEstimate,
      completedAt: Date.now(),
      deckType,
    };

    await this.roomRepo.saveVotingRound(roomId, round);
    return round;
  }
}
